import React from 'react';
import "../assets/scss/components/content.scss";

const Content = ({ children, ...props }) => {
    return (
        children &&
        <div className="appcontent">
            {children}
        </div>
    );
};

export default Content;
